import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="outerPageLoader">
      <div className="cont"></div>

      <div className="is-animate">
        <div className="l">l</div>
        <div className="l">o</div>
        <div className="l">a</div>
        <div className="l">d</div>
        <div className="l">i</div>
        <div className="l">n</div>
        <div className="l">g</div>
      </div>
    </div>
  );
};

export default Loading;
